// 接口配置文件
import axios from "axios";
//引入router
import router from "../router"
// 引入elementui
import ElementUI from 'element-ui';

//判断环境是不是开发环境，是就代理，不是就源地址
// axios.defaults.baseURL = process.env.NODE_ENV === "development" ? "http://192.168.20.245:8099" : "https://config.pujie88.com/api/v2"
axios.defaults.baseURL = process.env.NODE_ENV === "development" ? "/api" : "https://config.pujie88.com/api/v2/"
// axios.defaults.baseURL = process.env.NODE_ENV === "development" ? 'http://192.168.20.66:8099' : "http://192.168.20.171:8099"
// //配置系统2.0地址：https://config.pujie88.com/api/v2/
// axios.defaults.withCredentials = true;//允许请求携带认证//跨域？
axios.defaults.timeout =  60000;
console.log("axios.defaults.baseURL",axios.defaults.baseURL)

// axios.create({
//     baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://config.pujie88.com/api/v2/', // url = base url + request url
//     withCredentials: true, // send cookies when cross-domain requests
//     timeout: 600000 // request timeout
// });

// 添加请求拦截器,给每个请求都携带上想要传递的内容
axios.interceptors.request.use( config=> {//config是每个请求对象
    // 将token给到一个前后台约定好的key中，作为请求发送
    //登录注册不需要携带token
    // console.log(config);
    if(config.url == "/subLogin"){
        //直接放行
        return config
    }else{
        let token = localStorage.getItem('token')
        let Token
        let token1
        if (token.indexOf('"') !== -1) {
            console.log("token包含双引号字符串");
            token1 = token.substr(1); //删除首字符
            Token = token1.substring(0,token1.length-1); //删除最后末字符
            console.log('Token',Token)
        } else {
            console.log("token不包含双引号字符串");
        }
        config.headers['token'] = Token
        //放行
        return config
    }   
},error => {
    // return Promise.reject(error);
});

// //响应拦截用户非法访问，校验token是否正确
axios.interceptors.response.use(config=>{
    // console.log("response config",config)
    if(config.data.code == 0 || config.data.code == 200){
        
    }else{
        console.log("config",config,config.config.url)
        let url = config.config.url
        if(url.indexOf("exportModule") != -1){
            console.log("exportModule")
        }else if(url.indexOf("exportElementDevice") != -1){
            console.log("exportElementDevice")
        }else{
            ElementUI.Message({
                message: config.data.message,
                type: 'error'
            });
        }
        
        if(config.data.code == 402){
            //402代表如果token校验失败，提示错误并跳回登录页
            ElementUI.Message.error("登录信息失效，请重新登录")
            //引入router直接写
            router.push("/")
        }
    }
    return config
},error => {
    // return Promise.reject(error);
});

export default axios;


// WEBPACK FOOTER //
// ./src/api/config.js